"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileLike = void 0;
var core_services_1 = require("@iotv/core-services");
Object.defineProperty(exports, "getFileLike", { enumerable: true, get: function () { return core_services_1.getFileLike; } });
